import { sendTimeCardsToPayroll, getBatchOperation } from '@lib/api'
import { timeCardKeys } from '@lib/keys'
import { useQueryClient, useMutation } from '@tanstack/react-query'
import { BatchOperationStatus } from 'types'

export const useSendToPayroll = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (timeCardIds: number[]) => {
      // sendTimeCardsToPayroll endpoint returns a Batch Operation,
      // which performs all work asynchronously. We must
      // poll the Batch Operation status until it is completed,
      // then we resolve the mutation.
      let { batchOperation } = await sendTimeCardsToPayroll(timeCardIds)

      return new Promise((resolve, reject) => {
        const poll = async () => {
          try {
            batchOperation = await getBatchOperation(batchOperation.id)

            if (batchOperation.status === BatchOperationStatus.Completed) {
              resolve(batchOperation)
            } else if (batchOperation.status === BatchOperationStatus.Failed) {
              reject(new Error('Batch operation failed'))
            } else {
              // Continue polling every 2 seconds
              setTimeout(() => void poll(), 2000)
            }
          } catch (error) {
            reject(error)
          }
        }

        poll().catch((error) => {
          // Handle any unexpected errors during polling
          reject(error)
        })
      })
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(timeCardKeys.all)
      },
    },
  )
}
